import React, { useState, useEffect } from 'react';
import companyService from '../../../services/companyService';
import type { ICompany } from '../../../types/company';

const CompaniesSection: React.FC = () => {
  const [companies, setCompanies] = useState<ICompany[]>([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const data = await companyService.getFeaturedCompanies();
        setCompanies(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCompanies();
  }, []);

  if (companies.length === 0) return null; // Don't render the section if there are no featured companies

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-center text-2xl font-semibold text-gray-700 mb-8">
          Our Students Are Placed At
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {companies.map(company => (
            <div key={company._id} className="grayscale hover:grayscale-0 transition-all duration-300">
              <img src={company.logo} alt={company.name} className="h-12" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompaniesSection;